// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"a344ccc1","208":"286616d9","221":"828049af","453":"34258626","503":"ce8f6459","520":"fb2d7131","584":"214bf08a","826":"325339ef"}[chunkId] + ".chunk.js";
};